module.exports = __webpack_public_path__ + "img/ru_success_1.1f29c960.png";